import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgxBarcode6Module} from 'ngx-barcode6';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {SharedModule} from '../shared/shared.module';
import {CartComponent} from './components/cart/cart.component';
import {ProductsGridComponent} from './components/products-grid/products-grid.component';
import {ShowEanComponent} from './components/show-ean/show-ean.component';
import {ProductEditComponent} from './components/product-edit/product-edit.component';
import {I18NextModule} from 'angular-i18next';
import {ReactiveFormsModule} from '@angular/forms';
import {CoreModule} from '../../core/core.module';

@NgModule({
  declarations: [
    CartComponent,
    ProductsGridComponent,
    ShowEanComponent,
    ProductEditComponent
  ],
  exports: [
    CartComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CarouselModule,
    NgxBarcode6Module,
    SharedModule,
    I18NextModule,
    ReactiveFormsModule,
    CoreModule
  ]
})
export class CartModule {
}
